import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { breakpoints } from '@chegg-ui/theme';
export function useMaxMatchMedia(breakpoint) {
  var matches = function matches() {
    return typeof window !== 'undefined' && window.matchMedia && window.matchMedia("(max-width: ".concat(breakpoints[breakpoint].max, ")")).matches;
  };

  var _useState = useState(matches()),
      _useState2 = _slicedToArray(_useState, 2),
      isMatched = _useState2[0],
      setIsMatched = _useState2[1];

  useEffect(function () {
    /** ToDo - add test case for resize */

    /* istanbul ignore next */
    var matchMediaListner = function matchMediaListner() {
      setIsMatched(matches());
    }; // set resize listener


    window.addEventListener('resize', matchMediaListner); // clean up function

    return function () {
      // remove resize listener
      window.removeEventListener('resize', matchMediaListner);
    };
  }, []);
  return isMatched;
}